
//export const API_URL_API = '/api/'
//export const API_URL = '/'
//export const NATIVE_API_STORAGE = '/storage/'

//export const API_URL_API_REMOTE = 'http://localhost:8000/api/'
//export const API_URL_REMOTE = 'http://localhost:8000/'
//export const API_STORAGE_REMOTE = 'http://localhost:8000/storage/'

//export const API_URL_API_REMOTE = 'https://sygmalmdassur.com/api/'
//export const API_URL_REMOTE = 'https://sygmalmdassur.com/'
//export const API_STORAGE_REMOTE = 'https://sygmalmdassur.com/storage/'


export const API_URL_API_REMOTE = 'https://sygmamanitouassur.com/api/'
export const API_URL_REMOTE = 'https://sygmamanitouassur.com/'
export const API_STORAGE_REMOTE = 'https://sygmamanitouassur.com/storage/'

//export const SOCKET_URL = 'http://localhost:3000'
//export const SOCKET_KEY = "Sygma@1234"

